const showcaseData = [
    {
        id: 1,
        image: 'https://i.ibb.co/b2j6YwS/22.png',
        title: 'Drowler the Prowler',
        description: 'He’s a desperate thieving cowboy yearning to find the jackpot someday.',
    },
    {
        id: 2,
        image: 'https://i.ibb.co/g6LXDhb/47.png',
        title: 'Zacian',
        description: 'He is known as the “drip god” and he always looking for the next best thing to show off.',
    },
    {
        id: 3,
        image: 'https://i.ibb.co/4NWzv4V/30.png',
        title: 'Nomu the Gomu',
        description: 'His white fur turns into spikes any time there is something or someone that can cause damage to him.',
    },
];

export default showcaseData;
